var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26686(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26686",
    "data-name": "Group 26686",
    transform: "translate(-148 -788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(148 788)",
    fill: "#fb7b18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23247",
    "data-name": "Path 23247",
    d: "M174.336,83.11h4.69V97.18h2.931V83.11h4.69V97.18h3.517V83.11h4.69V97.18h2.931V83.11h4.69V97.495c.044.022.088-.015.132.081l3.517,2.345a2.346,2.346,0,0,1-1.3,4.294H171.991a2.344,2.344,0,0,1-1.3-4.294l3.517-2.345c.042-.1.085-.059.128-.081ZM187.241,67a2.351,2.351,0,0,1,2.33,0L202.153,74.2l.257.117v.066l3.576,2a2.348,2.348,0,0,1-1.231,4.382H171.925a2.346,2.346,0,0,1-1.1-4.382l3.442-2v-.066l.386-.117Z",
    transform: "translate(-4.646 738.305)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26686);
export default __webpack_public_path__ + "static/media/Group 26686.510eb0440c42b8c8df139ab341670aea.svg";
export { ForwardRef as ReactComponent };